import { Injectable, EventEmitter } from '@angular/core';
import { CategoriaInscripcion } from '../../models/categoriaInscripcion.model';

@Injectable()
export class ModalCategInscService {

  hide: string = 'hide-modal';
  categoria: CategoriaInscripcion = new CategoriaInscripcion();

  public notification = new EventEmitter<any>();

  constructor() { }

  showModal(categoria ?: CategoriaInscripcion) {
    if (categoria) {
      this.categoria = categoria;
    }
    this.hide = '';
  }

  hideModal() {
    this.hide = 'hide-modal';
    this.categoria = new CategoriaInscripcion();
    this.notification.emit(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal-categ-insc/modal-categ-insc.service.ts